const faqMexico = {
  stackText: 'FAQS',
  titleText: 'Preguntas frecuentes',
  frequentlyAskedQuestions: [
    {
      id: 'faq-1',
      question: '¿Qué es Fingo y qué hace?',
      answer: 'Fingo es una financiera 100% digital que entrega soluciones de financiamiento para empresas de forma rápida, simple y flexible. '
      + 'A través de nuestra plataforma puedes adelantar el cobro de tus facturas electrónicas sin esperar el pago de tu cliente.'
      + '\n\nAdemás, te ayudamos a flexibilizar el pago a tus proveedores a través de herramientas como Confirming y Pronto Pago, que fortalecen tu cadena de suministro sin afectar tu flujo de caja. '
      + 'Con Fingo puedes operar, financiarte y gestionar tus pagos desde un solo lugar, con condiciones competitivas y procesos 100% digitales pensados para acompañar el crecimiento de tu negocio.',
    },
    {
      id: 'faq-2',
      question: '¿Cómo operar con Fingo?',
      answer: [
        {
          id: 0,
          type: 'enumerated',
          text: [
            'Regístrate en nuestra plataforma.',
            'Vincula tu cuenta del SAT para visualizar automáticamente todas tus facturas de forma sencilla y segura.',
            'Completa y firma el formulario de buró de crédito para calcular una línea de crédito.',
            'Selecciona el servicio de financiamiento que necesites: ',
          ],
        },
        {
          id: 1,
          type: 'tabular',
          paddingLeft: '2rem',
          text: [
            'Factoraje: Tus facturas se cargarán automáticamente. Simula tu anticipo, cede las facturas que elijas y recibe el dinero al instante.',
            'Confirming y Pronto Pago: Un ejecutivo te contactará para evaluar tu línea de financiamiento. Luego, solo debes subir la nómina de facturas'
            + 'de los proveedores que quieres pagar de forma anticipada o con más plazo. Nosotros nos hacemos cargo de informar a tus proveedores.',
          ],
        },
      ],
    },
    {
      id: 'faq-3',
      question: '¿Cuáles son los costos de operar?',
      answer: [
        {
          id: 0,
          type: 'text',
          text: 'Operar con Fingo implica un costo competitivo y transparente que aplica para todos nuestros servicios. Este costo está compuesto principalmente por: ',
        },
        {
          id: 1,
          type: 'enumerated',
          paddingLeft: '2rem',
          text: [
            'Una tasa que se calcula según el nivel de riesgo de tu empresa y el de tu cliente.',
            'Una comisión por el servicio, que es baja y justa.',
          ],
        },
        {
          id: 2,
          type: 'text',
          text: 'Además, en todos los productos aplicamos una retención preventiva en caso de que haya mora en el pago. Si la retención no se utiliza, se convierte en un excedente que puedes solicitar para que te sea'
          + 'depositado en tu cuenta bancaria. Este excedente estará disponible una vez que se hayan cancelado los intereses por mora y otras posibles deudas.',
        },
      ],
    },
    {
      id: 'faq-4',
      question: '¿Qué documentos necesito para operar con Fingo?',
      answer: [
        {
          id: 0,
          type: 'text',
          text: 'Para comenzar a operar con Fingo, primero debes vincular tu cuenta con el SAT para que puedas visualizar automáticamente tus facturas. '
          + 'Sube los siguientes documentos:',
        },
        {
          id: 1,
          type: 'tabular',
          paddingLeft: '2rem',
          text: [
            'Actas constitutivas',
            'Balances financieros de los últimos períodos',
          ],
        },
        {
          id: 2,
          type: 'text',
          text: 'Rellenar y firmar formularios de buró de crédito:',
        },
        {
          id: 3,
          type: 'tabular',
          paddingLeft: '2rem',
          text: [
            'Persona física',
            'Persona moral (o PFAE)',
          ],
        },
        {
          id: 4,
          type: 'text',
          text: 'Estos documentos nos permiten evaluar correctamente tu línea de crédito y con esto solicitar anticipo de facturas.',
        },
      ],
    },
  ],
};

export default faqMexico;
